module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-3-fb8cef06293aa85a70ed7fdd84292d85.webp";